/*
 * This store holds all the user selections which will appear in the summary selections pane
 *
 */

const state = {
   enrolmentType: "",
   feeType: "",
   courseType: "",
   commencementYear: "",
   error: "Please add/remove units to meet total credits",
   selectedItems: [],
   course: null,
   locked: false,
   studentID: "",
}

const getters = {
   getEnrolmentType: state => {
      return state.enrolmentType;
   },
   getFeeType: state => {
      return state.feeType;
   },
   getCourseType: state => {
      return state.courseType;
   },
   getCommencementYear: state => {
      return state.commencementYear;
   },
   getError: state => {
      return state.error;
   },
}

const mutations = {
   setEnrolmentType(state, data) {
      state.enrolmentType = data;
   },
   setFeeType(state, data) {
      state.feeType = data;
   },
   setCourseType(state, data) {
      state.courseType = data;
   },
   setCommencementYear(state, data) {
      state.commencementYear = data;
   },
   addSelectedItem(state, data) {
      state.selectedItems.push(data);
   },
   removeSelectedItem(state, data) {
      state.selectedItems = state.selectedItems.filter(item => item.location != data.location)
   },
   clearSelectedItems(state) {
      state.selectedItems = [];
   },
   setCourse(state, data) {
      state.course = data;
   },
   setLocked(state, data) {
      state.locked = data;
   },
   setStudentID(state, data) {
      state.studentID = data;
   }
}

const actions = {
   setEnrolmentType(context, input) {
      context.commit('setEnrolmentType', input);
   },
   setFeeType(context, input) {
      context.commit('setFeeType', input);
   },
   setCourseType(context, input) {
      context.commit('setCourseType', input);
   },
   setCommencementYear(context, input) {
      context.commit('setCommencementYear', input);
   },
   addSelectedItem(context, input) {
      context.commit('addSelectedItem', input);
   },
   removeSelectedItem(context, input) {
      context.commit('removeSelectedItem', input);
   },
   clearSelectedItems(context) {
      context.commit('clearSelectedItems');
   },
   setCourse({ state, commit, rootState, rootGetters }, data) {
      commit("setCourse", data);
   },
   setLocked({ state, commit, rootState, rootGetters }, data) {
      commit("setLocked", data);
   },
   setStudentID({ state, commit, rootState, rootGetters }, data) {
      commit("setStudentID", data);
   },
}

export default {
   state,
   getters,
   actions,
   mutations
}
